"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useLocale, useTranslations } from "next-intl";
import { InstantSearch, Chat, ChatOverlayLayout } from "react-instantsearch";
import type { UIMessage } from "instantsearch.js/es/lib/chat";
import "instantsearch.css/components/chat.css";
import "./agent-chat.css";
import { searchClient } from "@/lib/algolia/client";
import { getAlgoliaIndexName } from "@/lib/algolia/config";
import { AgentResultItem } from "./agent-result-item.component";
import type { AgentHit } from "./agent-chat.types";
interface AgentChatProps {
  agentId?: string;
}
export function AgentChat(t0) {
  const $ = _c(25);
  const {
    agentId
  } = t0;
  const locale = useLocale();
  const t = useTranslations("search");
  let t1;
  if ($[0] !== locale) {
    t1 = getAlgoliaIndexName(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const indexName = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("chatbotIntro");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = [{
      id: "agent-chat-intro",
      role: "assistant",
      parts: [{
        type: "text",
        text: t2
      }]
    }];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const initialMessages = t3;
  const resolvedAgentId = agentId ?? process.env.NEXT_PUBLIC_ALGOLIA_AGENT_ID ?? "";
  if (!resolvedAgentId) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[agent-chat] NEXT_PUBLIC_ALGOLIA_AGENT_ID is not set \u2014 Chat widget will not render.");
    }
    return null;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      autoFocus: false
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("chatbotTitle");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = {
      title: t5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("chatbotDisclaimer");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = {
      disclaimer: t7
    };
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = {
      header: t6,
      prompt: t8
    };
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== initialMessages || $[19] !== resolvedAgentId || $[20] !== t9) {
    t10 = <Chat agentId={resolvedAgentId} layoutComponent={ChatOverlayLayout} promptProps={t4} translations={t9} messages={initialMessages} itemComponent={_temp} />;
    $[18] = initialMessages;
    $[19] = resolvedAgentId;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== indexName || $[23] !== t10) {
    t11 = <div className="agent-chat-theme"><InstantSearch searchClient={searchClient} indexName={indexName}>{t10}</InstantSearch></div>;
    $[22] = indexName;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(t0) {
  const {
    item
  } = t0;
  return <AgentResultItem item={item} />;
}
export function openAgentChat(attemptsLeft = 20): void {
  if (typeof document === "undefined") return;
  const btn = document.querySelector<HTMLButtonElement>(".ais-ChatToggleButton");
  // The widget mounts lazily (see AgentChatDeferred), so the toggle button may
  // not be in the DOM yet when this is called — retry briefly until it is.
  if (!btn) {
    if (attemptsLeft > 0) {
      window.setTimeout(() => openAgentChat(attemptsLeft - 1), 100);
    }
    return;
  }
  if (!btn.classList.contains("ais-ChatToggleButton--open")) {
    btn.click();
  }
}